import {doc, deleteDoc} from 'firebase/firestore';
import {getCurrentUserIdValidated} from '../../config/firebaseUser';
import {getTradeCollection} from './getTradeCollection';

export async function deleteTrade(id: string): Promise<void> {
  const uid = await getCurrentUserIdValidated();
  const colRef = getTradeCollection(uid);
  const ref = doc(colRef, id);
  await deleteDoc(ref);
}
